const mapStyle = 'https://tiles.openfreemap.org/styles/liberty';

const makePopup = store => {
  const card = document.createElement('div');
  const title = document.createElement('strong');
  const address = document.createElement('span');
  const directions = store.element.querySelector('.mp-store-action--directions');

  title.textContent = store.name;
  address.textContent = store.element.querySelector('address')?.textContent.trim() || '';
  card.className = 'mp-store-map-popup';
  card.append(title, address);

  if (directions?.href) {
    const link = document.createElement('a');
    link.href = directions.href;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.textContent = 'Directions';
    link.setAttribute('aria-label', `Directions to ${store.name} (opens in a new tab)`);
    card.append(link);
  }

  return card;
};

const initialiseStoreMap = mapElement => {
  if (!window.maplibregl) return;
  const locator = mapElement.closest('[data-mp-store-locator]');
  const stores = [...locator.querySelectorAll('[data-mp-store]')].map(element => ({
    element,
    name: element.dataset.storeName,
    latitude: Number(element.dataset.storeLatitude),
    longitude: Number(element.dataset.storeLongitude),
  })).filter(store => Number.isFinite(store.latitude) && Number.isFinite(store.longitude));

  if (!stores.length) return;

  const map = new window.maplibregl.Map({
    container: mapElement,
    style: mapStyle,
    center: [77.575, 12.96],
    zoom: 11.6,
    attributionControl: true,
  });
  map.addControl(new window.maplibregl.NavigationControl({ showCompass: false }), 'top-right');

  const mapViewport = mapElement.parentElement;
  const locateButton = mapViewport?.querySelector('[data-mp-map-locate]');
  const locationStatus = mapViewport?.querySelector('[data-mp-map-location-status]');
  let userMarker;
  const showLocationStatus = message => {
    if (!locationStatus) return;
    locationStatus.textContent = message;
    locationStatus.removeAttribute('hidden');
  };

  locateButton?.addEventListener('click', () => {
    if (!navigator.geolocation) {
      showLocationStatus('Location is not available in this browser.');
      return;
    }
    locateButton.disabled = true;
    locateButton.setAttribute('aria-busy', 'true');
    showLocationStatus('Finding your location…');
    navigator.geolocation.getCurrentPosition(position => {
      const center = [position.coords.longitude, position.coords.latitude];
      const userMarkerElement = document.createElement('span');
      userMarkerElement.className = 'mp-store-map__user-marker';
      userMarkerElement.setAttribute('aria-hidden', 'true');
      userMarker?.remove();
      userMarker = new window.maplibregl.Marker({ element: userMarkerElement, anchor: 'center' }).setLngLat(center).addTo(map);
      map.flyTo({ center, zoom: 13, duration: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 500, essential: true });
      showLocationStatus('Map centred on your location. Your location is not saved.');
      locateButton.disabled = false;
      locateButton.removeAttribute('aria-busy');
    }, () => {
      showLocationStatus('We could not access your location. You can choose a store pin instead.');
      locateButton.disabled = false;
      locateButton.removeAttribute('aria-busy');
    }, { enableHighAccuracy: false, maximumAge: 300000, timeout: 10000 });
  });

  const bounds = new window.maplibregl.LngLatBounds();
  stores.forEach(store => {
    const markerElement = document.createElement('button');
    markerElement.type = 'button';
    markerElement.className = 'mp-store-map__marker';
    markerElement.setAttribute('aria-label', `${store.name}: show directions`);
    const marker = new window.maplibregl.Marker({ element: markerElement, anchor: 'center' })
      .setLngLat([store.longitude, store.latitude])
      .setPopup(new window.maplibregl.Popup({ offset: 20 }).setDOMContent(makePopup(store)))
      .addTo(map);
    bounds.extend([store.longitude, store.latitude]);
    store.marker = marker;
  });

  map.on('load', () => map.fitBounds(bounds, { padding: 48, maxZoom: 13, duration: 0 }));
  locator.addEventListener('mp:nearest-store', event => {
    const nearest = stores.find(store => store.name === event.detail.name);
    if (!nearest) return;
    stores.forEach(store => store.marker.getPopup()?.remove());
    nearest.marker.togglePopup();
    map.flyTo({ center: [nearest.longitude, nearest.latitude], zoom: 13, duration: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 500, essential: true });
  });
};

document.querySelectorAll('[data-mp-store-map]').forEach(initialiseStoreMap);
